var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "job--edit--languages-item" },
    [
      _c("h3", [
        _c("span", [
          _vm._v(_vm._s(_vm.item.item.label) + " (Mindestvoraussetzung)")
        ]),
        _vm._v(" "),
        _c("span", [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.$emit("remove")
                }
              }
            },
            [_c("Icon", { attrs: { icon: "bin" } })],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        _vm._l(_vm.specificityTypes, function(specificityTypeAllocation) {
          return _c(
            "b-col",
            { key: specificityTypeAllocation.specificityType.id },
            [
              _c(
                "FormGroup",
                {
                  staticClass: "mt-2",
                  attrs: {
                    label: specificityTypeAllocation.specificityType.label
                  }
                },
                [
                  _c("Select", {
                    attrs: {
                      value: _vm.getValue(specificityTypeAllocation),
                      options: _vm.getOptions(specificityTypeAllocation)
                    },
                    on: {
                      input: function($event) {
                        return _vm.setValue(specificityTypeAllocation, $event)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }